import { render, staticRenderFns } from "./split.vue?vue&type=template&id=26acbfa5"
import script from "./split.vue?vue&type=script&lang=js"
export * from "./split.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports